import PropTypes from 'prop-types'
import React from 'react'

export const ShowCounter = ({count}) => (
  // <p>Broj pregleda oglasa: {count}</p>
  null
)

ShowCounter.propTypes = {
  count: PropTypes.number.isRequired
}

ShowCounter.defaultProps = {
  count: 0
}
